import { breakpoints } from '@/themes/themeOverrides/Breakpoints';
import { Palette } from '@/themes/themeOverrides/Palette';

export const collapsibleSectionStyles = {
    '&.collapsible-section': {
        borderTop: `2px solid ${Palette.gray.gray100}`,
        marginTop: '-2px',
        [`@media (max-width: ${breakpoints.values.md}px)`]: {
            marginTop: '0',
        },
    },
    '&.collapsible-section--open': {
        backgroundColor: Palette.white,
    },
    '&.collapsible-section--closed': {
        backgroundColor: Palette.gray.gray75,
    },
    '& .popup-box--header': {
        cursor: 'pointer',
        alignItems: 'center',
        [`@media (max-width: ${breakpoints.values.md}px)`]: {
            padding: '20px',
        },
        '& .MuiTypography-h5': {
            marginBottom: '0 !important',
            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                fontSize: '18px',
            },
        },
        '& .MuiIconButton-root': {
            padding: '12px !important',
            [`@media (max-width: ${breakpoints.values.md}px)`]: {
                padding: '8px !important',
            },
        },
    },
    '& .collapsible-section__title': {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
    },
    '& .padding-wrapper': {
        borderTop: 'none',
        padding: '0 56px 40px',
        [`@media (max-width: ${breakpoints.values.md}px)`]: {
            padding: '0 20px 40px',
        },
    },
    '& .padding-wrapper-inner': {
        position: 'relative',
    },
    '& .padding-wrapper-inner--has-separator': {
        paddingTop: '40px',
        '&::before': {
            content: '""',
            display: 'block',
            width: '100%',
            height: '2px',
            backgroundColor: Palette.gray.gray75,
            position: 'absolute',
            top: '0',
            left: '50%',
            transform: 'translateX(-50%)',
        },
    },
};
